import _ from 'underscore';
import ko from 'knockout';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!component/language-selector');
const s$AdGroup = window.globalLegacySchema.get('AdGroup');

export default class ViewModel {
  constructor(options = {
    language: 'English',
  }) {
    const Inherit = null;

    // When passed form options, show only ones got from there
    // In other case, language is AdGroup level property, Arabic and Simplified Chinese are not Supported Languages. We should not show them.
    let languages = _.isEmpty(options.languages) ?
      _.without(s$AdGroup.properties.Language.enum, 'All', 'None') :
      options.languages;

    if (!options.enableSimplifiedChinese) {
      languages = _.without(languages, 'SimplifiedChinese');
    }

    if (!options.IsAdsGlobalizationPhase1Enabled) {
      languages = _.without(languages, 'Greek', 'Polish', 'Bulgarian', 'Croatian', 'Czech', 'Estonian', 'Hungarian', 'Latvian', 'Lithuanian', 'Maltese', 'Romanian', 'Slovak', 'Slovenian');
    }

    if (!options.IsAdsGlobalizationPhase2Enabled) {
      languages = _.without(languages, 'Turkish', 'Serbian', 'Bosnian', 'Albanian', 'Macedonian', 'Icelandic');
    }

    if (!options.IsAdsGlobalizationPhase6Enabled) {
      languages = _.without(languages, 'Hebrew', 'Arabic', 'Russian');
    }

    if (!options.IsAdsGlobalizationPhase2JapanEnabled) {
      languages = _.without(languages, 'Japanese');
    }

    if (!options.IsAdsGlobalizationPhase9Enabled) {
      languages = _.without(languages, 'Hindi', 'Malay', 'Thai', 'Indonesian', 'Tagalog');
    }

    if (!options.IsAdsGlobalizationPhase9VIEnabled) {
      languages = _.without(languages, 'Vietnamese');
    }

    if (options.IsDomesticSimplifiedChineseEnabled) {
      languages = ['SimplifiedChinese'];
    }

    this.languageOptions = _.chain(languages)
      .sortBy()
      .map((language) => {
        return {
          'Text': i18n.get(`Language_${language}`),
          'Value': language,
        };
      })
      .value();

    if (options.withInheritOption) {
      this.languageOptions.unshift({
        'Text': i18n.get('Language_Inherit'),
        'Value': Inherit,
      });
    }

    //language should be got from MT depending on currentUser, hardcode here in first iteration
    this.language = ko.observable(options.language);

    this.disabled = ko.observable(false);
  }
}
